import axios from '@/libs/api.request'

/**
 * 保存备注
 */
export const saveRemark = (id, remark_shop, remark_admin, express, express_num) => {
    let data ={
        "id": id,
        "remark_shop": remark_shop,
        "remark_admin": remark_admin,
        "express": express,
        "express_num": express_num
    }
    return axios.request({
        url: '/api/admin/order/saveRemark',
        data,
        method: 'post'
    })
}

/**
 * 订单确认
 */
export const confirmOrder = (ids) => {
    let data ={
        "ids": ids
    }
    return axios.request({
        url: '/api/admin/order/confirmOrder',
        data,
        method: 'post'
    })
}

/**
 * 订单发货
 */
export const sendOrder = (ids) => {
    let data ={
        "ids": ids
    }
    return axios.request({
        url: '/api/admin/order/sendOrder',
        data,
        method: 'post'
    })
}

/**
 * 订单退款
 */
export const refundOrder = (ids) => {
    let data ={
        "ids": ids
    }
    return axios.request({
        url: '/api/admin/order/refundOrder',
        data,
        method: 'post'
    })
}

/**
 * 订单退款-部分
 */
 export const refundOrderPart = (id, money, remark) => {
    let data ={
        "id": id,
        "money": money,
        "remark": remark
    }
    return axios.request({
        url: '/api/admin/order/refundOrderPart',
        data,
        method: 'post'
    })
}

/**
 * 订单退款
 */
 export const refundOrderNew = (ids) => {
    let data ={
        "ids": ids
    }
    return axios.request({
        url: '/api/admin/order/refundOrderNew',
        data,
        method: 'post'
    })
}

/**
 * 订单退款-部分
 */
 export const refundOrderPartNew = (id, money, remark) => {
    let data ={
        "id": id,
        "money": money,
        "remark": remark
    }
    return axios.request({
        url: '/api/admin/order/refundOrderPartNew',
        data,
        method: 'post'
    })
}

/**
 * 导出订单
 */
 export const exportOrder = (order_status, sn, receiver, receiver_phone, start_date, end_date) => {
    const data = {
        "order_status": order_status,
        "sn": sn,
        "receiver": receiver,
        "receiver_phone": receiver_phone,
        "start_date": start_date,
        "end_date": end_date
    }
    return axios.request({
        url: '/api/admin/order/export',
        data,
        method: 'post'
    })
}